"use strict";
/**
 * Enum for api status values.
 * @readonly
 * @enum {number}
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiStatusCode = void 0;
var ApiStatusCode;
(function (ApiStatusCode) {
    ApiStatusCode[ApiStatusCode["Unauthorized"] = 401] = "Unauthorized";
    ApiStatusCode[ApiStatusCode["BadRequest"] = 400] = "BadRequest";
    ApiStatusCode[ApiStatusCode["Forbidden"] = 403] = "Forbidden";
    ApiStatusCode[ApiStatusCode["NotFound"] = 404] = "NotFound";
    ApiStatusCode[ApiStatusCode["TimeOut"] = 408] = "TimeOut";
    ApiStatusCode[ApiStatusCode["InternalServerError"] = 500] = "InternalServerError";
})(ApiStatusCode || (exports.ApiStatusCode = ApiStatusCode = {}));
